/* global axios */

import ApiClient from 'dashboard/api/ApiClient';

class ChannelTemplatePresets extends ApiClient {
  constructor() {
    super('custom/inboxes', { accountScoped: true });
  }

  presetUrl(inboxId, templateKey = '') {
    const suffix = templateKey ? `/${encodeURIComponent(templateKey)}` : '';
    return `${this.url}/${inboxId}/template_presets${suffix}`;
  }

  list(inboxId) {
    return axios.get(this.presetUrl(inboxId));
  }

  catalog(inboxId, { purpose, conversationId }) {
    return axios.get(`${this.presetUrl(inboxId)}/catalog`, {
      params: { purpose, conversation_id: conversationId },
    });
  }

  upsert(inboxId, templateKey, payload) {
    return axios.put(this.presetUrl(inboxId, templateKey), payload);
  }

  remove(inboxId, templateKey, language) {
    return axios.delete(this.presetUrl(inboxId, templateKey), {
      params: { language },
    });
  }

  resolve(inboxId, templateKey, { language, purpose, conversationId }) {
    return axios.post(`${this.presetUrl(inboxId, templateKey)}/resolve`, {
      language,
      purpose,
      conversation_id: conversationId,
    });
  }

  uploadMedia(
    inboxId,
    templateKey,
    { language, purpose, conversationId, file }
  ) {
    const payload = new FormData();
    payload.append('language', language);
    payload.append('purpose', purpose);
    if (conversationId) payload.append('conversation_id', conversationId);
    payload.append('file', file);
    return axios.post(`${this.presetUrl(inboxId, templateKey)}/media`, payload);
  }
}

export default new ChannelTemplatePresets();
